
const MIN_DESKTOP_SCREEN_WIDTH = 1023;
const isDesktopScreen = () => {
    return window.innerWidth > MIN_DESKTOP_SCREEN_WIDTH;
}

export default isDesktopScreen;